import { Contact } from '../../../components/address-book';
import { SaveAddressResponse } from '../../../global-types';

export const mapSavedAddressToContact = (
  savedAddress: SaveAddressResponse,
  accountId: string | undefined,
): Contact | null => {
  const addressResponseData = savedAddress.data;
  if (!addressResponseData || !accountId) {
    return null;
  }

  return {
    account_id: accountId,
    contact_id: addressResponseData?.address_id || '',
    address_hash_id: addressResponseData.address_hash_id || '',
    address_line_1: addressResponseData.address_line_1,
    address_line_2: addressResponseData.address_line_2,
    city: addressResponseData.city,
    company_name: addressResponseData.company_name,
    contact_type_code: addressResponseData.address_type_code,
    country_code: addressResponseData.country_code,
    created_at: addressResponseData.created_at,
    first_name: addressResponseData.first_name,
    last_name: addressResponseData.last_name,
    last_updated_at: addressResponseData.last_updated_at,
    state_code: addressResponseData.state_code,
    zip: addressResponseData.zip,
    is_verified: addressResponseData.is_verified,
  };
};
